export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#0F1F2E] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0 L50 50 L100 0' stroke='%23C9A961' fill='none' stroke-width='0.5'/%3E%3C/svg%3E")`,
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-4">
            <div className="flex items-center space-x-2 mb-6">
              <img 
                src="https://static.readdy.ai/image/8ee4107a0391ff41e9853657d04e9e24/11ab73c7ebd49d098a25df4db0ff452f.jpeg" 
                alt="AMD Gestion Immobilière" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-xl font-serif text-white/90 leading-relaxed mb-6">
              La tranquillité de vos biens,<br />même à distance.
            </p>
            <div className="flex items-center space-x-3">
              <input
                type="email"
                placeholder="Votre email"
                className="flex-1 bg-white/10 border border-white/20 text-white px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-white/50"
              />
              <button className="w-10 h-10 bg-[#C9A961] rounded-full flex items-center justify-center hover:bg-[#D4B56F] transition-colors cursor-pointer">
                <i className="ri-notification-line text-white"></i>
              </button>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-bold text-lg mb-4 text-white">Services</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Gestion locative
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Conciergerie
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Surveillance
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-bold text-lg mb-4 text-white">Entreprise</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('solution')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Notre approche
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('methode')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Notre méthode
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('zones')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Zones d'intervention
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-bold text-lg mb-4 text-white">Ressources</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('transparence')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Charte qualité
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Exemple rapport
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-bold text-lg mb-4 text-white">Contact</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://wa.me/221XXXXXXXXX"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact.amd.immo@gmail.com"
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Email
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-white/70 hover:text-[#C9A961] transition-colors text-sm cursor-pointer"
                >
                  Formulaire
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#C9A961]/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-white/60 text-sm">
              © 2025 AMD Gestion Immobilière & Conciergerie Premium. Tous droits réservés.
            </p>

            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer"
              >
                <i className="ri-linkedin-fill text-white"></i>
              </a>
              <a
                href="https://wa.me/221XXXXXXXXX"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:border-[#C9A961] hover:bg-[#C9A961]/10 transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}